import request from "@/utils/request";


// 机器人配置
export function saveWebhookurl( data) {
    return request({
        url: "/c/user/saveWebhookurl",
        method: "post",
        data,

    });
}
